const requestHeaderNames = {
    CONTENT_TYPE: 'Content-Type',
    AUTHORIZATION: 'Authorization',
};

export default requestHeaderNames;
